const htmlMediaEvents = {
  progress: 'progress',
  timeupdate: 'timeupdate',
  play: 'play',
  playing: 'playing',
  waiting: 'waiting',
  ended: 'ended',
  error: 'error',
  seeked: 'seeked',
  metadata: 'metadata',
};

export default htmlMediaEvents;
